module.exports = __webpack_public_path__ + "static/media/sd-icon.cd25059e.svg";